export default function toggleValidators() {
  function toggleBlockedValidator(){
    // no payload to validate
    return true;
  }
  function showWarningValidator(){
    // no payload to validate
    return true;
  }
  function makeRequestValidator(value){
    if(typeof value !== 'boolean') {
      throw Error(`
			Payload should be a boolean.
			Got: ${value}
		`)
    }
    return true;
  }
  function updateValidator(value){
    if(typeof value !== 'boolean') {
      throw Error(`
			Payload should be a boolean.
			Got: ${value}
		`)
    }
    return true;
  }

  return {
    toggleBlockedValidator,
    showWarningValidator,
    makeRequestValidator,
    updateValidator
  }
}